import {
  Autocomplete,
  Box,
  Checkbox,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  SelectChangeEvent,
  Stack,
  Tab,
  Tabs,
  TextField,
} from "@mui/material";
import Title from "../components/ui/Title";
import styled from "styled-components";
import { useState } from "react";

import CheckBoxOutlineBlankIcon from "@mui/icons-material/CheckBoxOutlineBlank";
import CheckBoxIcon from "@mui/icons-material/CheckBox";
import { CustomTabPanel } from "../components/ui/CustomTabPanel";
import ReturnDataTable from "../components/features/returns/ReturnDataTable";

const RateCard = () => {
  const [plan, setPlan] = useState("1");

  const handleChange = (event: SelectChangeEvent) => {
    setPlan(event.target.value as string);
  };
  const [activeTab, setActiveTab] = useState(0);
  const handleTabChange = (_event: React.SyntheticEvent, newValue: number) => {
    setActiveTab(newValue);
  };

  const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
  const checkedIcon = <CheckBoxIcon fontSize="small" />;

  return (
    <>
      <Stack direction={"row"} gap={2} marginBottom={2}>
        <Title title="Rate Card" />
        <FormControl
          sx={{ minWidth: 150, backgroundColor: "#fff" }}
          size="small"
        >
          <InputLabel id="demo-select-small-label">Plan</InputLabel>
          <Select
            labelId="demo-select-small-label"
            id="demo-select-small"
            value={plan}
            label="Select Plan"
            onChange={handleChange}
          >
            <MenuItem value={1}>Lite</MenuItem>
            <MenuItem value={2}>Basic</MenuItem>
            <MenuItem value={3}>Advanced</MenuItem>
            <MenuItem value={4}>Pro</MenuItem>
          </Select>
        </FormControl>
      </Stack>

      <StyleOrder>
        <FiltersDiv>
          <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
            <Tabs
              value={activeTab}
              onChange={handleTabChange}
              variant="scrollable"
            >
              <Tab sx={{ textTransform: "None" }} label="Forward" />
              <Tab sx={{ textTransform: "None" }} label="Reverse" />
              <Tab sx={{ textTransform: "None" }} label="Document" />
              {/* <Tab sx={{ textTransform: "None" }} label="" /> */}
            </Tabs>

            <FormControl
              sx={{
                width: 250,
                margin: "20px 0",
              }}
              size="small"
            >
              <Autocomplete
                size="small"
                multiple
                id="checkboxes-tags-demo"
                options={top100Films}
                disableCloseOnSelect
                getOptionLabel={(option) => option.title}
                renderOption={(props, option, { selected }) => (
                  <li {...props}>
                    <Checkbox
                      icon={icon}
                      checkedIcon={checkedIcon}
                      style={{ marginRight: 8 }}
                      checked={selected}
                    />
                    {option.title}
                  </li>
                )}
                // style={{ width: 300 }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Select Couriers"
                    sx={{
                      fontSize: "2px",
                    }}
                    placeholder="select couriers"
                  />
                )}
              />
            </FormControl>

            <FormControl
              sx={{
                width: 250,
                margin: "20px 20px",
              }}
              size="small"
            >
              <Autocomplete
                size="small"
                multiple
                id="checkboxes-tags-demo"
                options={modesList}
                disableCloseOnSelect
                getOptionLabel={(option) => option.title}
                renderOption={(props, option, { selected }) => (
                  <li {...props}>
                    <Checkbox
                      icon={icon}
                      checkedIcon={checkedIcon}
                      style={{ marginRight: 8 }}
                      checked={selected}
                    />
                    {option.title}
                  </li>
                )}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Select Modes"
                    sx={{
                      fontSize: "2px",
                    }}
                    placeholder="select modes"
                  />
                )}
              />
            </FormControl>

            <FormControl
              sx={{
                width: 250,
                margin: "20px 20px",
              }}
              size="small"
            >
              <Autocomplete
                size="small"
                multiple
                id="checkboxes-tags-demo"
                options={weightList}
                disableCloseOnSelect
                getOptionLabel={(option) => option.title}
                renderOption={(props, option, { selected }) => (
                  <li {...props}>
                    <Checkbox
                      icon={icon}
                      checkedIcon={checkedIcon}
                      style={{ marginRight: 8 }}
                      checked={selected}
                    />
                    {option.title}
                  </li>
                )}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Select Weight"
                    sx={{
                      fontSize: "2px",
                    }}
                    placeholder="select Weight"
                  />
                )}
              />
            </FormControl>
          </Box>
        </FiltersDiv>

        <CustomTabPanel value={activeTab} index={0}>
          <ReturnDataTable />
        </CustomTabPanel>
        <CustomTabPanel value={activeTab} index={1}>
          <ReturnDataTable />
        </CustomTabPanel>
        <CustomTabPanel value={activeTab} index={2}>
          <ReturnDataTable />
        </CustomTabPanel>
        <CustomTabPanel value={activeTab} index={3}>
          <ReturnDataTable />
        </CustomTabPanel>
        <CustomTabPanel value={activeTab} index={4}>
          <ReturnDataTable />
        </CustomTabPanel>
        <CustomTabPanel value={activeTab} index={5}>
          <ReturnDataTable />
        </CustomTabPanel>
        <CustomTabPanel value={activeTab} index={6}>
          <ReturnDataTable />
        </CustomTabPanel>
        <CustomTabPanel value={activeTab} index={7}>
          <ReturnDataTable />
        </CustomTabPanel>
        <CustomTabPanel value={activeTab} index={8}>
          <ReturnDataTable />
        </CustomTabPanel>
        <CustomTabPanel value={activeTab} index={9}>
          <ReturnDataTable />
        </CustomTabPanel>
      </StyleOrder>
    </>
  );
};

const StyleOrder = styled.div`
  width: 100%;
  background-color: #fff;
  border-radius: 10px;
  padding: 20px;
  box-shadow: 1px 2px 7px 0px rgba(0, 0, 0, 0.05);
`;

const FiltersDiv = styled.div`
  display: flex;
  justify-content: space-between;
  margin: 10px 0;
  margin-bottom: 50px;
`;

const weightList = [
  { title: "0.25 kg", value: 0.25 },
  { title: "0.5 kg", value: 0.5 },
  { title: "1 kg", value: 1 },
  { title: "2 kg", value: 2 },
  { title: "5 kg", value: 5 },
  { title: "10 kg", value: 10 },
];

const modesList = [
  { title: "Air", value: 1 },
  { title: "Surface", value: 2 },
  { title: "HyperLocal", value: 3 },
];

const top100Films = [
  { title: "option 1" },
  { title: "option 2" },
  { title: "option 3" },
  { title: "option 4" },
  { title: "option 5" },
  { title: "option 6" },
  { title: "option 7" },
  { title: "option 8" },
  { title: "option 9" },
  { title: "option 10" },
];
export default RateCard;
